import listActions from 'src/modules/registro/list/registroListActions';
import RegistroService from 'src/modules/registro/registroService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'REGISTRO_DESTROY';

const registroDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: registroDestroyActions.DESTROY_STARTED,
      });

      await RegistroService.destroyAll([id]);

      dispatch({
        type: registroDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.registro.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/registro');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: registroDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: registroDestroyActions.DESTROY_ALL_STARTED,
      });

      await RegistroService.destroyAll(ids);

      dispatch({
        type: registroDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.registro.destroyAll.success'),
      );

      getHistory().push('/registro');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: registroDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default registroDestroyActions;
